import React, { Component } from 'react';

const { Provider, Consumer } = React.createContext();

class InitHomeLoanProvider extends Component {
  state = {
    firstname: '',
    middlename: '',
    lastname: '',
    bday: '',
    citizenship: '',
    sex: '',
    civilStatus: '',
    spouseName: '',
    spouseBday: '',
    spouseEmployer: '',
    spouseIncome: '',
    numberOfDependents: '',
    motherMaidenName: '',
    cityAddress: '',
    provincialAddress: '',
    cityMunicipalityProvince: '',
    zipCode: '',
    lengthOfStay: '',
    typeOfResidence: '',
    carOwned: '',
    homeAreaCode: '',
    homePhone: '',
    mobilePhone: '',
    emailAddress: '',
    education: '',
    tin: '',
    sss: '',
    gsis: '',
    loanAmount: '',
    loanTerm: '',
    loanPurpose: '',
    collateralType: '',
    collateralUse: '',
    coborrowersName: '',
    propertyMortgaged: '',
    bankFinancialInstitution: '',
    mortgageAmount: '',
    outstandingBalance: '',
    monthlyAmortization: '',
    bankName: '',
    bankDeposit: '',
    bankAccount: '',
    typeOfEmployment: '',
    employerName: '',
    lengthOfService: '',
    rankPosition: '',
    typeOfJob: '',
    faxNumber: '',
    businessName: '',
    businessNature: '',
    businessDateRegistered: '',
    businessPhone: '',
    lengthOfOperation: '',
    placeOfBusiness: '',
    monthlyIncome: '',
    // referenceNumber: '',
  };

  render() {
    return (
      <Provider
        value={{
            firstname: this.state.firstname,
            middlename: this.state.middlename,
            lastname: this.state.lastname,
            bday: this.state.bday,
            citizenship: this.state.citizenship,
            sex: this.state.sex,
            civilStatus: this.state.civilStatus,
            spouseName: this.state.spouseName,
            spouseBday: this.state.spouseBday,
            spouseEmployer: this.state.spouseEmployer,
            spouseIncome: this.state.spouseIncome,
            numberOfDependents: this.state.numberOfDependents,
            motherMaidenName: this.state.motherMaidenName,
            cityAddress: this.state.cityAddress,
            provincialAddress: this.state.provincialAddress,
            cityMunicipalityProvince: this.state.cityMunicipalityProvince,
            zipCode: this.state.zipCode,
            lengthOfStay: this.state.lengthOfStay,
            typeOfResidence: this.state.typeOfResidence,
            carOwned: this.state.carOwned,
            homeAreaCode: this.state.homeAreaCode,
            homePhone: this.state.homePhone,
            mobilePhone: this.state.mobilePhone,
            emailAddress: this.state.emailAddress,
            education: this.state.education,
            tin: this.state.tin,
            sss: this.state.sss,
            gsis: this.state.gsis,
            // autoType: this.state.autoType,
            // autoBrand: this.state.autoBrand,
            // autoModel: this.state.autoModel,
            // autoCashPrize: this.state.autoCashPrize,
            // downpayment: this.state.downpayment,
            // amountFinanced: this.state.amountFinanced,
            // autoTerms: this.state.autoTerms,
            loanAmount: this.state.loanAmount,
            loanTerm: this.state.loanTerm,
            loanPurpose: this.state.loanPurpose,
            collateralType: this.state.collateralType,
            collateralUse: this.state.collateralUse,
            coborrowersName: this.state.coborrowersName,
            propertyMortgaged: this.state.propertyMortgaged,
            bankFinancialInstitution: this.state.bankFinancialInstitution,
            mortgageAmount: this.state.mortgageAmount,
            outstandingBalance: this.state.outstandingBalance,
            monthlyAmortization: this.state.monthlyAmortization,
            bankName: this.state.bankName,
            bankDeposit: this.state.bankDeposit,
            bankAccount: this.state.bankAccount,
            typeOfEmployment: this.state.typeOfEmployment,
            employerName: this.state.employerName,
            lengthOfService: this.state.lengthOfService,
            rankPosition: this.state.rankPosition,
            typeOfJob: this.state.typeOfJob,
            faxNumber: this.state.faxNumber,
            businessName: this.state.businessName,
            businessNature: this.state.businessNature,
            businessDateRegistered: this.state.businessDateRegistered,
            businessPhone: this.state.businessPhone,
            lengthOfOperation: this.state.lengthOfOperation,
            placeOfBusiness: this.state.placeOfBusiness,
            monthlyIncome: this.state.monthlyIncome,
            // referenceNumber: this.state.referenceNumber,
          handleInputChange: (event) => {
            const target = event.target;
            const value = target.value;
            const firstname = target.name;

            this.setState({
              [firstname]: value
            });
          },
          updateState: (sname,inval) => {
            this.setState({
              [sname]: inval
            })
          },
          resetForm: () => {
            this.setState({
                firstname: '',
                middlename: '',
                lastname: '',
                bday: '',
                citizenship: '',
                sex: '',
                civilStatus: '',
                spouseName: '',
                spouseBday: '',
                spouseEmployer: '',
                spouseIncome: '',
                numberOfDependents: '',
                motherMaidenName: '',
                cityAddress: '',
                provincialAddress: '',
                cityMunicipalityProvince: '',
                zipCode: '',
                lengthOfStay: '',
                typeOfResidence: '',
                carOwned: '',
                homeAreaCode: '',
                homePhone: '',
                mobilePhone: '',
                emailAddress: '',
                education: '',
                tin: '',
                sss: '',
                gsis: '',
                loanAmount: '',
                loanTerm: '',
                loanPurpose: '',
                collateralType: '',
                collateralUse: '',
                coborrowersName: '',
                propertyMortgaged: '',
                bankFinancialInstitution: '',
                mortgageAmount: '',
                outstandingBalance: '',
                monthlyAmortization: '',
                // autoType: '',
                // autoBrand: '',
                // autoModel: '',
                // autoCashPrize: '',
                // downpayment: '',
                // amountFinanced: '',
                // autoTerms: '',
                bankName: '',
                bankDeposit: '',
                bankAccount: '',
                typeOfEmployment: '',
                employerName: '',
                lengthOfService: '',
                rankPosition: '',
                typeOfJob: '',
                faxNumber: '',
                businessName: '',
                businessNature: '',
                businessDateRegistered: '',
                businessPhone: '',
                lengthOfOperation: '',
                placeOfBusiness: '',
                monthlyIncome: '',
                // referenceNumber:'',
            })
          }
        }}
      >
        {this.props.children}
      </Provider>
    );
  }
}

export { InitHomeLoanProvider, Consumer };